import { createSlice } from "@reduxjs/toolkit";
import Swal from 'sweetalert2';
import { getAllAdmin, submitAdmin, deleteAdmin } from "./Utils/adminUtils";

const initialState = {
    filters: {
        "filter[id]": "",
        "filter[name]": "",
        "filter[email]": "",
        "filter[is_super_admin]": "",
        "filter[is_admin]": "",
        "filter[is_cs]": "",
        "sort": "",
        "page": "",
    },
    admins: [],
    pagination: {},
    loading: false,
    error: null,
    currentAdmin: {  // Ini buat menyimpan data form yang lagi aktif
        id: null,
        name: "",
        email: "",
        password: "",
        is_super_admin: null,
        is_admin: null,
        is_cs: null,
        branch_id: null,
    }
};

const adminSlice = createSlice({
    name: "admin",
    initialState,
    reducers: {
        setFormData: (state, action) => {
            state.currentAdmin = { ...state.currentAdmin, ...action.payload };
        },
        resetFormData: (state) => {
            state.currentAdmin = initialState.currentAdmin;
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters: (state) => {
            state.filters = initialState.filters;
        }
    },
    extraReducers: (builder) => {
        builder
            // Handle getAllAdmin
            .addCase(getAllAdmin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllAdmin.fulfilled, (state, action) => {
                state.loading = false;
                state.admins = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(getAllAdmin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Handle submitAdmin (update atau tambah admin)
            .addCase(submitAdmin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(submitAdmin.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Berhasil disimpan',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
                if (!state.admins.find(admin => admin.id === action.payload.id)) {
                    state.admins.push(action.payload);
                } else {
                    state.admins = state.admins.map(admin => 
                        admin.id === action.payload.id ? action.payload : admin
                    );
                }
                state.currentAdmin = initialState.currentAdmin;
            })
            .addCase(submitAdmin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Handle deleteAdmin
            .addCase(deleteAdmin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteAdmin.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Berhasil dihapus',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
                state.admins = state.admins.filter(admin => admin.id !== action.payload.id);
            })
            .addCase(deleteAdmin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});
export const { setFormData, resetFormData, setFilters, resetFilters } = adminSlice.actions;
export default adminSlice.reducer;